module.exports = __webpack_public_path__ + "static/media/favicon.a3c45385.ico";